
export const services = [
    {
        title: "Software Engineer",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Traveller",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Sports Enthusiast",
        icon: 'https://csgeeek.github.io/web.png',
    },
];

export const name = 'Abhishek';

export const experiences = [    
    {
        'company': 'Park Square Homes',
        'role': 'Programmer Analyst',
        'duration': 'Jun 2025 - Present',
        'logo': 'https://www.google.com/imgres?q=park%20square%20homes&imgurl=https%3A%2F%2Fmedia.parksquarehomes.com%2F393%2F2024%2F5%2F15%2Fpark-square-logo.png%3Fwidth%3D521%26height%3D524%26fit%3Dbounds%26ois%3Dcdfed24&imgrefurl=https%3A%2F%2Fwww.parksquarehomes.com%2Fdesign-studio%2F&docid=KD8EsJWKZsLexM&tbnid=fT1ijl1g9TC24M&vet=12ahUKEwix_p2y5YCQAxXRSjABHUXuFj0QM3oECBcQAA..i&w=521&h=524&hcb=2&ved=2ahUKEwix_p2y5YCQAxXRSjABHUXuFj0QM3oECBcQAA',
        'points': [
            'Developed and maintained modules of a large-scale ERP system using C#, .NET MVC, and SQL Server Management Studio (SSMS) for database management.',
            'Utilized Microsoft Azure for task workflows, version control, sprint planning with Azure Boards, and automated deployments through Azure Pipelines.',
            'Built and optimized interactive reports with DevExpress, improving data visualization and business insights.',
            'Managed issue tracking and project management with Jira in an agile environment.'
        ],
        'url': 'https://www.parksquarehomes.com/',
    },
    {
        'company': 'University of Texas at Arlington',
        'role': 'Engineering Research Assistant',
        'duration': 'Aug 2024 - Jun 2025',
        'logo': 'https://upload.wikimedia.org/wikipedia/en/thumb/2/29/University_of_Texas_at_Arlington_seal.svg/1200px-University_of_Texas_at_Arlington_seal.svg.png',
        'points': [
            'Built Java microservices with Spring Boot, using Stream API & Lambdas to boost performance by 30%.',
            'Secured APIs with JWT authentication & OAuth2, ensuring protected access to endpoints and sensitive data.',
            'Improved database performance with Hibernate ORM, reducing manual effort by 35%.',
            'Integrated unit testing with JUnit to ensure code quality and reliability, identifying issues early and improving overall software robustness.'
        ],
        'url': 'https://www.uta.edu/',
    },
    {
        'company': 'Orbit Tours and Travels',
        'role': 'Software Engineer',
        'duration': 'Jun 2020 - Apr 2022',
        'logo': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTSjC47R2X0_Apg6PjHuZohpF_XZ6da0mvyfw&s',
        'points': [
            'Led migration of on-premises applications to AWS with multi-AZ & multi-region architectures for high availability.',
            'Developed backend services using Java and Spring Boot, following MVC architecture for modular design.',
            'Optimized database performance and reduced query execution time by 40%, leading to faster response times.',
            'Implemented CI/CD pipelines in Azure DevOps using YAML and Docker, streamlining deployment and scaling.'
        ],
        'url': 'https://www.facebook.com/orbittoursandtravels/',
    },
    {
        'company': 'Caypro Technologies',
        'role': 'Software Engineer Intern',
        'duration': 'Dec 2019 - Apr 2020',
        'logo': 'https://media.licdn.com/dms/image/C4D0BAQGJNms_rAb_Qw/company-logo_200_200/0/1630545901277/talentnow_solution_service_pvt_ltd_logo?e=2147483647&v=beta&t=Ips5gXvYZNteu0fBOLbMqSBT4UiqCSqNnVw3pDcsln8',
        'points': [
            'Developed a dynamic interactive ReactJs-based UI dashboard to showcase comprehensive reports and improved user productivity by enabling easy filtering of downtime reports.',
            'Implemented Redux middleware to manage side effects, querying and improved application performance by 20%.',
            'Optimized the MySQL schema, improving query execution latency and ensuring efficient database normalization.',
            'Implemented RESTful APIs for backend integration, ensuring data flow and performance across different modules.'
        ],
        'url': 'https://www.caypro.io/',
    },
    
]



export const EMAIL_JS_SERVICE_ID = 'service_ifnovy8';
export const EMAIL_JS_TEMPLATE_ID = 'template_bxrlyz8';
export const EMAIL_JS_PUBLIC_KEY = '3gyE0ZFr-myjQES5b';